module.exports = __webpack_public_path__ + "img/empty-box.2703f81c.png";